import { PAYMENT_METHOD_KV_MAP } from 'src/consumer/constants'

export function checkIfReportNeedsReconsiliationForTherapists(report) {
  if (
    report?.paymentMethod !== PAYMENT_METHOD_KV_MAP.BOOKING_FEE_PAYMENT_METHOD_COLLECTED_BY_AUMHUM
  ) {
    return false
  }
  return report?.feeCollected === report?.feeCollectedFromPatient
}
